module.exports = __webpack_public_path__ + "static/media/ks-banner.bb8aa226.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ks-banner.png
// module id = 1542
// module chunks = 0